import { render, staticRenderFns } from "./crudPortabilityTemplate.vue?vue&type=template&id=1654c407&scoped=true&"
import script from "./crudPortabilityTemplate.vue?vue&type=script&lang=js&"
export * from "./crudPortabilityTemplate.vue?vue&type=script&lang=js&"
import style0 from "./crudPortabilityTemplate.vue?vue&type=style&index=0&id=1654c407&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1654c407",
  null
  
)

export default component.exports